export const vatFormats = {
  SE: 'SEXXXXXXXXXXXX',
  NO: 'XXXXXXXXXMVA',
  DK: 'DKXXXXXXXX',
  PL: 'PLXXXXXXXXXX',
  FI: 'FIXXXXXXXX',
  IT: 'ITXXXXXXXXXXX',
  DE: 'DEXXXXXXXXX',
  FR: 'FRXXXXXXXXXXX',
  ES: 'ESXXXXXXXXX',
  GB: 'GBXXXXXXXXX',
  CZ: 'CZXXXXXXXX or CZXXXXXXXXX or CZXXXXXXXXX',
  AT: 'ATUXXXXXXXX',
  BE: 'BEXXXXXXXXXX',
  BG: 'BGXXXXXXXXX or BGXXXXXXXXXX',
  HR: 'HRXXXXXXXXXXX',
  EE: 'EEXXXXXXXXX',
  EL: 'ELXXXXXXXXX',
  HU: 'HUXXXXXXXX',
  IE: 'IEXXXXXXXX or IEXXXXXXXXX',
  LV: 'LVXXXXXXXXXXX',
  LT: 'LTXXXXXXXXX or LTXXXXXXXXXXXX',
  LU: 'LUXXXXXXXX',
  MT: 'MTXXXXXXXX',
  NL: 'NLXXXXXXXXXBXX',
  PT: 'PTXXXXXXXXX',
  CY: 'CYXXXXXXXXX',
  RO: 'ROXXXXXXXXXX',
  SI: 'SIXXXXXXXX',
  SK: 'SKXXXXXXXXXX',
}

export const validSSNMap = {
  defualt:
    /(^(((20)([0-5][0-9]))|((19)\d{2}))((((0[13578])|(1[02]))(([0-2][0-9])|(3[01])))|(((0[469])|(11))(([0-2][0-9])|(30)))|(02[0-2][0-9]))[-]\d{4}$)|(^\*{8}-\*{4}$)/,
  PL: /(^((\d{2}))((0[1-9])|1[0-2])((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1]))\d{5}$)|(^\*{11}$)/,
  DE: /^(((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$)|(^\*{1,}$)/,
  NO: /(^(((([0-2][0-9])|(3[01]))((0[13578])|(1[02])))|((([0-2][0-9])|(30))((0[469])|(11)))|([0-2][0-9]02))([0-9][0-9])[ ]\d{5}$)|(^\*{6} \*{5}$)/,
  NL: /(^\d{9}$)/,
}
